const pages = {
  INDEX: 'index',
  CART: 'cart',
  CHECKOUT: 'checkout',
  ORDER_SUMMARY: 'order_summary',
  ACCOUNT: 'account',
  WISHLIST: 'wishlist',
  BILLING: 'billing',
  ACCOUNT_INFO: 'account_info',
  INVOICES: 'invoices',
  ADDRESSES: 'addresses',
  ACCOUNT_USERS: 'users',
  AGREEMENTS: 'agreements',
  ORDERS_HISTORY: 'orders_history',
  RFQ: 'rfq',
  OFFERS: 'offers',
  CONTACT: 'contact',
  ROLES: 'roles',
  ORDER_AUTHORIZATION: 'order_authorization',
  OFFLINE_ORDERS: 'offline_orders',
  ONLINE_ORDERS: 'online_orders',
  GOODS_ISSUE_NOTES: 'goods_issue_notes',
  GOODS_RECEIVED_NOTES: 'goods_received_notes',
  COMPLAINS: 'complains',
  INVOICES_GOODS_ISSUE_NOTES: 'invoices_goods_issue_notes',
  BLOG: 'blog',
  RFQS_OFFERS: 'rfqs_offers',
}
export default pages
